import React, {Component} from "react";
import {checkIfMobile, isTrue} from "../utils/utils";
import {Button, Col, Input, message, Row} from "antd";
import {LockOutlined} from "@ant-design/icons";
import {Form} from "@ant-design/compatible";
import {Link} from "react-router-dom";
import {MorphleLogo} from "../utils/const";
import '@ant-design/compatible/assets/index.css';
import '../asset/style/login.css'
import cookie from "react-cookies";
import {post_response} from "../helper/request";
import querystring from "query-string";
import ForceLogout from "../component/settings/force_logout";
import PasswordChecklist from "react-password-checklist";

const {Password} = Input;

class UpdatePassword extends Component {

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            isFetching: false,
            selectedUserUsername: '',
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: '',
            errorFlag: false,
            errorMessage: '',
            showLogoutModal: false,
        };
    }

    componentDidMount = () => {
        const storedModalState = localStorage.getItem('showLogoutModal');
        if (storedModalState) {
            this.setState({showLogoutModal: JSON.parse(storedModalState)});
        }
        let isMobile = checkIfMobile();
        document.documentElement.style.setProperty('--login-div-size', isMobile ? "20em" : "40em");
    }

    oldPasswordFieldChange = (e) => {
        this.setState({
            oldPassword: e.target.value,
            errorFlag: false,
            errorMessage: '',
        });
    }

    passwordFieldChange = (e) => {
        this.setState({
            newPassword: e.target.value,
            errorFlag: false,
            errorMessage: '',
        });
    }

    confirmPasswordFieldChange = (e) => {
        this.setState({
            confirmNewPassword: e.target.value,
            errorFlag: false,
            errorMessage: '',
        });
    }

    handleSubmit = e => {
        e?.preventDefault();
        const complexPasswordCheck = (cookie.load("organisation_setting") || {})["complex_password_check"];
        this.setState({isFetching: true});

        if (this.state.oldPassword.length < 1) {
            this.setState({
                errorFlag: true,
                errorMessage: 'Please enter old password, Compulsory field',
                newPassword: '',
                confirmNewPassword: '',
                isFetching: false,
            });
            return;
        }
        if (this.state.newPassword.length < 8) {
            this.setState({
                errorFlag: true,
                errorMessage: 'Use 8 characters or more for your password.',
                confirmNewPassword: '',
                isFetching: false,
            });
            return;
        } else if (this.state.newPassword !== this.state.confirmNewPassword) {
            this.setState({
                errorFlag: true,
                errorMessage: 'Passwords didn\'t match. Please try again.',
                confirmNewPassword: '',
                isFetching: false,
            });
            return;
        }
        const passwordRegex = /^(?:(?=.*[a-z])(?:(?=.*[A-Z])(?=.*[\d\W])|(?=.*\W)(?=.*\d))|(?=.*\W)(?=.*[A-Z])(?=.*\d)).{8,}$/;
        if (isTrue(complexPasswordCheck) && !passwordRegex.test(this.state.newPassword)) {
            this.setState({
                errorFlag: true,
                errorMessage: 'Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character.',
                newPassword: '',
                confirmNewPassword: '',
                isFetching: false,
            });
            return;
        }

        let val = {
            username: cookie.load('username'),
            password: this.state.newPassword,
            oldPassword: this.state.oldPassword,
        }
        let url = `/api/update_user_password/`;
        post_response(url, querystring.stringify(val))
            .then(response => {
                if (response.status === 200 || response.status === 301 || response.status === 302) {
                    message.success("Password changed successfully.", 2.5);
                    this.setState({showLogoutModal: true});
                    localStorage.setItem('passwordChangedByOtherUser', JSON.stringify(false))
                    localStorage.setItem('showLogoutModal', JSON.stringify(true));
                } else if (response.status === 403 || response.status === 401 || response.status === 400) {
                    message.error("Some error occurred. Not able to change password.", 2.5);
                }
            })
            .catch((err) => {
                let msg = err?.response?.data || "Some error occured. Not able to change password."
                message.error(msg, 2.5);
                this.setState({
                    oldPassword: '',
                    newPassword: '',
                    confirmNewPassword: '',
                    isFetching: false,
                    errorFlag: true,
                    errorMessage: msg,
                });
            });
    };

    handleCloseLogoutModal = () => {
        localStorage.setItem("showLogoutModal", "false")
        this.setState({showLogoutModal: false});
    };

    renderForm() {
        const complexPasswordCheck = (cookie.load("organisation_setting") || {})["complex_password_check"];
        const passwordRegex = /^(?:(?=.*[a-z])(?:(?=.*[A-Z])(?=.*[\d\W])|(?=.*\W)(?=.*\d))|(?=.*\W)(?=.*[A-Z])(?=.*\d)).{8,}$/;
        const passwordDisable = isTrue(complexPasswordCheck) ? !passwordRegex.test(this.state.newPassword) ||
            (this.state.newPassword !== this.state.confirmNewPassword) : false;

        return <>
            <Row>
                <Col span={24}>
                    <Password placeholder={"Enter Old Password"} value={this.state.oldPassword}
                              prefix={<LockOutlined style={{color: "rgba(0,0,0,.25)"}}/>}
                              onChange={this.oldPasswordFieldChange} autoComplete="old-password"/>
                </Col>
            </Row>
            <br/>
            <Row>
                <Col span={24}>
                    <Password placeholder="Enter New Password" value={this.state.newPassword}
                              prefix={<LockOutlined style={{color: "rgba(0,0,0,.25)"}}/>}
                              onChange={this.passwordFieldChange} autoComplete="new-password"/>
                </Col>
            </Row>
            <br/>
            <Row>
                <Col span={24}>
                    <Password placeholder="Confirm New Password" value={this.state.confirmNewPassword}
                              prefix={<LockOutlined style={{color: "rgba(0,0,0,.25)"}}/>}
                              onChange={this.confirmPasswordFieldChange} autoComplete="new-password"/>
                </Col>
            </Row>
            {isTrue((cookie.load("organisation_setting") || {})["complex_password_check"]) &&
                <Row style={{marginTop: 30}}>
                    <Col span={24}>
                        <div className="password-rules" style={{fontStyle: 'italic'}}>
                            {this.state.newPassword.length > 0 ?
                                <PasswordChecklist
                                    style={{margin: 10}}
                                    rules={["minLength", "capital", "lowercase", "number", "specialChar", "match"]}
                                    minLength={8}
                                    value={this.state.newPassword}
                                    valueAgain={this.state.confirmNewPassword}
                                    onChange={(isValid) => {
                                    }}
                                /> : <>
                                    <p>Password must:</p>
                                    <ul>
                                        <li>Be 8 to 32 characters long</li>
                                        <li>Contain at least one uppercase letter</li>
                                        <li>Contain at least one lowercase letter</li>
                                        <li>Contain at least one digit</li>
                                        <li>Contain at least one special character</li>
                                        <li>Match the Confirm Password</li>
                                    </ul>
                                </>
                            }
                        </div>
                    </Col>
                </Row>}
            {this.state.errorFlag ?
                <div>
                    <Row>
                        <Col>
                            <div className="error-message-general"> {this.state.errorMessage} </div>
                        </Col>
                    </Row><br/>
                </div> : <><br/><br/></>
            }
            <Row>
                <Col span={24}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        className="login-form-button"
                        onClick={this.handleSubmit}
                        disabled={passwordDisable}
                        loading={this.state.isFetching}>
                        Enter
                    </Button>
                </Col>
            </Row>
        </>

    }

    renderPasswordContent() {
        let content = [];
        content.push(<p style={{fontSize: 16, textAlign: 'center'}}> Change Password </p>);
        content.push(<p style={{fontSize: 12, marginBottom: 30, textAlign: 'center'}}>
            Your password has been changed by another user. To ensure the security of your account,
            we recommend changing your password immediately. </p>)
        content.push(
            <Form ref={this.formRef}>
                {this.renderForm()}
            </Form>
        );

        return content;
    }

    render() {

        return (
            <>
                <Row className={'login-mp'}
                     style={{paddingTop: isTrue((cookie.load("organisation_setting") || {})["complex_password_check"]) ? '2%' : null}}>
                    <Col className="login-form overlayed-component">
                        <Link to={'/'}><img className="login-logo" src={MorphleLogo} alt={"Morphle Logo"}/></Link>
                        {this.renderPasswordContent()}
                    </Col>
                </Row>
                <ForceLogout visible={this.state.showLogoutModal} onClose={this.handleCloseLogoutModal}
                             message={'password'}/>
            </>
        );
    }
}

export default UpdatePassword;